import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
// import CommentSection from './components/CommentSection';
import WorkLogSection from './components/WorkLogSection';
import MaterialTypography from '../../../../../../../components/MaterialTypography';

const ActivitySection = ({ taskData }) => {
    const [tabIndex, setTabIndex] = useState(0);

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <Box sx={{ width: '100%', mt: 1 }}>
            <MaterialTypography variant='h6' color='dark' fontWeight='bold' mb={1}>Activity</MaterialTypography>
            <Tabs value={tabIndex} onChange={handleChange} aria-label="activity tabs">
                <Tab label="Comment" />
                <Tab label="Work Log" />
            </Tabs>

            <Box sx={{ mt: 2 }}>
                {tabIndex === 0 && (
                    <Box>
                        {/* <CommentSection taskData={taskData} /> */}
                    </Box>
                )}
                {tabIndex === 1 && (
                    <Box>
                        <WorkLogSection />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default ActivitySection;
